import { Navigate } from "react-router-dom";

import { ROUTER_PATHS } from "../../../shared/constants";

import { routesConfig } from "./routes-config";
import { Route } from "./types";
import { PrivateLayout } from "../ui/private-layout";
import { User } from "../../../entities/me";

const getRoutes = (user: User | null | undefined): Route[] =>
  routesConfig.map((route) => {
    if (route.private) {
      if (route.children) {
        return {
          ...route,
          element: user ? (
            route.element || <PrivateLayout />
          ) : (
            <Navigate to={`/${ROUTER_PATHS.AUTH.INDEX}`} />
          ),
        };
      }
      return {
        ...route,
        element: user ? (
          <PrivateLayout />
        ) : (
          <Navigate to={`/${ROUTER_PATHS.AUTH.INDEX}`} />
        ),
      };
    }
    return route;
  });

export default getRoutes;
